/*
 * Country overlay for the LUXHORA "Wave Your Flag" product.
 *
 * - When the country <select> (.country-overlay-select) changes, swaps the
 *   .country-overlay-img layer in the product media gallery and writes the slug into the
 *   hidden _Land-Slug line-item property input.
 * - Re-applies the current selection after a variant change, because product-info.js
 *   re-renders the media gallery (which would otherwise reset the overlay) and publishes
 *   PUB_SUB_EVENTS.variantChange ('variant-change') when done.
 *
 * The <select> itself is rendered outside product-info.js's re-render list, so the
 * customer's choice persists across body/pointer (variant) changes on its own.
 */
(function () {
  function applyOverlay(select) {
    if (!select) return;

    const option = select.options[select.selectedIndex];
    const overlayUrl = option ? option.getAttribute('data-overlay') : '';
    const slug = option ? option.getAttribute('data-slug') : '';

    const container = select.closest('.country-personalization-container') || document;
    const slugInput = container.querySelector('.country-overlay-slug');
    if (slugInput) slugInput.value = slug || '';

    document.querySelectorAll('.country-overlay-img').forEach((img) => {
      if (overlayUrl) {
        img.src = overlayUrl;
        img.style.display = '';
      } else {
        img.removeAttribute('src');
        img.style.display = 'none';
      }
    });
  }

  function applyAll() {
    document.querySelectorAll('.country-overlay-select').forEach((select) => applyOverlay(select));
  }

  function init() {
    const selects = document.querySelectorAll('.country-overlay-select');
    if (!selects.length) return;

    selects.forEach((select) => {
      if (select.dataset.countryOverlayBound) return;
      select.dataset.countryOverlayBound = 'true';
      select.addEventListener('change', () => applyOverlay(select));
      applyOverlay(select); // honour any pre-selected value on load
    });

    // Re-apply after a variant change re-renders the gallery (guard against double-subscribe).
    if (!window.__countryOverlayVariantSub && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.__countryOverlayVariantSub = subscribe(PUB_SUB_EVENTS.variantChange, applyAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
